import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { initLenis, destroyLenis, scrollTop } from "@/lib/scroll";
import { HeaderNav } from "@/components/HeaderNav";
import { Footer } from "@/components/Footer";
import { SplashScreen } from "@/components/SplashScreen";
import { RequestInventoryModal } from "@/components/RequestInventoryModal";
import { HomePage } from "@/pages/HomePage";
import { AboutPage } from "@/pages/AboutPage";
import { CapabilitiesPage } from "@/pages/CapabilitiesPage";
import { ExplorerPage } from "@/pages/ExplorerPage";
import { TrustPage } from "@/pages/TrustPage";
import { GalleryPage } from "@/pages/GalleryPage";
import { ContactPage } from "@/pages/ContactPage";

const ScrollReset = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollTop();
  }, [pathname]);
  return null;
};

function App() {
  const [splash, setSplash] = useState(true);
  const [modal, setModal] = useState({ open: false, interest: "Inventory request" });

  useEffect(() => {
    document.title = "Sunrays — Certified Loose Diamonds · Dubai JLT";
    initLenis();
    const t = setTimeout(() => setSplash(false), 2400);
    return () => {
      destroyLenis();
      clearTimeout(t);
    };
  }, []);

  const openInventory = () => setModal({ open: true, interest: "Inventory request" });
  const openQuote = () => setModal({ open: true, interest: "Exact quote request" });

  return (
    <div className="App grain" data-testid="sunrays-app">
      <BrowserRouter>
        <ScrollReset />
        <AnimatePresence>{splash && <SplashScreen />}</AnimatePresence>
        <HeaderNav onRequestInventory={openInventory} />
        <main>
          <Routes>
            <Route path="/" element={<HomePage onRequestInventory={openInventory} />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/capabilities" element={<CapabilitiesPage />} />
            <Route path="/explorer" element={<ExplorerPage onRequestQuote={openQuote} />} />
            <Route path="/trust" element={<TrustPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<HomePage onRequestInventory={openInventory} />} />
          </Routes>
        </main>
        <Footer />
        <RequestInventoryModal
          open={modal.open}
          onOpenChange={(open) => setModal((m) => ({ ...m, open }))}
          interest={modal.interest}
        />
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#17171b", border: "1px solid rgba(201,162,75,0.3)", color: "#fff" } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
